<template>
  <video
    class="general-video"
    loop
    :muted="mute"
    texture
    :ref="`general_video_${itemId}`"
    @click="toggleVideo()"
    :poster="thumbnail ? getVideoThumbnailUrl(thumbnail) : undefined"
    @posterror="handlePosterError"
    :style="{
      objectFit: imageMode,
    }"
  >
    <source :src="videoUrl" :type="itemType" @error="handleVideoError" />
    <source :src="defaultVideoUrl" :type="itemType" @error="handleDefaultVideoError" />
  </video>
</template>

<script>
  import playerMixins from '@/models/player';
  import { simpleTypeMixin } from '@/helpers';
  import { getItemLocalUrl, getItemUrl } from '@/utils/mediaAsset';
  import { logger } from '@/utils/screenEventsLogger';

  export default {
    name: 'GenericVideoPlayer',

    mixins: [playerMixins, simpleTypeMixin],

    props: {
      show: {
        type: Boolean,
        default: false,
      },
      itemId: {
        type: String,
        default: '',
      },
      itemType: {
        type: String,
        default: '',
      },
      itemUrl: {
        type: String,
        default: '',
      },
      imageMode: {
        type: String,
        default: 'cover',
      },
      thumbnail: {
        type: String,
        default: '',
      },
      mute: {
        type: Boolean,
        default: false,
      },
    },

    watch: {
      show(newShow) {
        if (newShow) {
          this.$refs[`general_video_${this.itemId}`].currentTime = 0;
          this.playVideo();
        }
      },
    },

    mounted() {
      if (this.show) {
        this.playVideo();
      }
    },

    computed: {
      videoUrl() {
        return getItemLocalUrl(this.itemUrl, this.itemId);
      },

      defaultVideoUrl() {
        return getItemUrl(this.itemUrl);
      },
    },

    methods: {
      playVideo() {
        const videoRef = this.$refs[`general_video_${this.itemId}`];
        if (!videoRef) return;
        videoRef.currentTime = 0;
        const playPromise = videoRef.play();

        // browsers released before 2019 may not return a value
        if (playPromise !== undefined) {
          playPromise.then((_) => {}).catch((_error) => {});
        }
      },

      toggleVideo() {
        if (this.isPlaying) {
          this.playVideo();
        } else {
          this.pauseVideo();
        }
      },

      pauseVideo() {
        this.$refs[`general_video_${this.itemId}`].pause();
      },

      handleVideoError() {
        logger.addLog(`Failed to load video: ${this.videoUrl}`);
      },

      handleDefaultVideoError() {
        logger.addLog(`Failed to load default video: ${this.defaultVideoUrl}`);
      },

      handlePosterError() {
        logger.addLog(`Failed to load poster: ${this.thumbnail}`);
      },

      getVideoThumbnailUrl(thumbnailUrl) {
        return getItemUrl(thumbnailUrl);
      },
    },
  };
</script>

<style lang="scss" scoped>
  .general-video {
    width: 100%;
    height: 100%;
  }
</style>
